/* MUDNAAZ — Size Chart Interactions */
(function(){
  'use strict';

  // ── Tabs
  document.querySelectorAll('.mn-sc-tab').forEach(function(tab){
    tab.addEventListener('click', function(){
      var target = tab.dataset.tab;
      document.querySelectorAll('.mn-sc-tab').forEach(function(t){ t.classList.remove('is-active'); });
      document.querySelectorAll('.mn-sc-panel').forEach(function(p){ p.classList.remove('is-active'); });
      tab.classList.add('is-active');
      var panel = document.getElementById('panel-' + target);
      if(panel) panel.classList.add('is-active');
    });
  });

  // ── Unit toggle (inches <> cm) — synced across all toggle instances
  var currentUnit = 'in';
  document.querySelectorAll('.mn-sc-unit-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var unit = btn.dataset.unit;
      if(unit === currentUnit) return;
      currentUnit = unit;
      // Remove active from every toggle button across all instances
      document.querySelectorAll('.mn-sc-unit-btn').forEach(function(b){ b.classList.remove('is-active'); });
      // Re-activate all buttons matching the selected unit (keeps hero + strip in sync)
      document.querySelectorAll('.mn-sc-unit-btn[data-unit="' + unit + '"]').forEach(function(b){ b.classList.add('is-active'); });
      // Update all unit labels in table headers
      document.querySelectorAll('.mn-sc-unit-label').forEach(function(el){
        el.textContent = unit === 'cm' ? '(cm)' : '(in)';
      });
      // Convert all data cells
      document.querySelectorAll('.mn-sc-table tbody td[data-in]').forEach(function(td){
        var inVal = parseFloat(td.dataset.in);
        if(isNaN(inVal)) return;
        td.textContent = unit === 'cm' ? (inVal * 2.54).toFixed(1) : td.dataset.in;
      });
    });
  });

})();